import styled, { css } from 'styled-components';
import { Text } from '@bufferapp/ui';
import { blueLight, red } from '@bufferapp/ui/style/colors';
import CrossIcon from '@bufferapp/ui/Icon/Icons/Cross';

export const CommentWrapper = styled.div`
  position: relative;
  display: flex;
  padding: 10px 16px;
`;

export const AvatarWrapper = styled.div`
  margin-right: 8px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 18px;
  min-width: 0;
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const AuthorText = styled(Text).attrs({ type: 'label' })<{
  isCommentCreator: boolean;
}>`
  margin-right: 5px;
  font-weight: 500;
  ${(props) =>
    props.isCommentCreator &&
    css`
      color: ${blueLight};
    `};
`;

export const CreatedAtText = styled(Text).attrs({ type: 'label' })`
  font-size: 12px;
  flex-shrink: 0;
`;

export const CommentText = styled(Text).attrs({ type: 'p' })`
  margin: 0;
`;

export const DeleteComment = styled(CrossIcon).attrs({ size: 'large' })`
  display: none;
  position: absolute;
  top: 5px;
  right: 12px;
  fill: ${red};
  cursor: pointer;

  ${CommentWrapper}:hover & {
    display: block;
  }
`;
